import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchGamePixGames } from '../../services/gameService';

const SkeletonCard = () => (
  <div className="rounded-xl overflow-hidden card-sm">
    <div className="relative w-full skeleton pb-[100%]" />
    <div className="h-3.5 mx-2 my-2 rounded bg-hover-theme" />
  </div>
);

const PremiumGames = ({ flag = 12 }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imgLoaded, setImgLoaded] = useState({});

  useEffect(() => {
    fetchGamePixGames(flag).then(setGames).catch(() => {}).finally(() => setLoading(false));
  }, [flag]);

  if (loading) return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-2 sm:gap-3">
      {Array.from({ length: flag }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-2 sm:gap-3">
      {games.map((game) => (
        <Link key={game.id || game.title} to={`/games?${game.url}&name=${game.title}`} className="block game-card-hover">
          <div className="rounded-xl overflow-hidden cursor-pointer card-sm">
            <div className="relative w-full pb-[100%]">
              {!imgLoaded[game.id] && <div className="absolute inset-0 skeleton" />}
              <img src={game.thumbnail || game.banner_image} alt={game.title} loading="lazy"
                className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-300 ${imgLoaded[game.id] ? 'opacity-100' : 'opacity-0'}`}
                onLoad={() => setImgLoaded(prev => ({ ...prev, [game.id]: true }))} />
              <div className="play-overlay">
                <div className="play-btn-circle">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="white">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="game-name">{game.title}</div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default PremiumGames;
